import httpMethod from 'services/update2025/httpMethod';
import { Confirmation } from "components/Confirmation";
import BlockDetail from "components/block-detail/BlockDetail";
import { VNeIDJobContext } from "components/vneid-job/VNeIDJobContext";
import { Can } from "configs/CASLContext";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiFillPauseCircle, AiFillPlayCircle } from "react-icons/ai";
import { FaRegClone } from "react-icons/fa";
import { callNodeVNeIDJob, findVNeIDJob, listServerVNeIDJob, listServiceNameVNeIDJob, reloadVNeIDJob } from "services/VNeIDJobService";
import { actionClone, actionUpdate, actionView } from "utils/action";
import { VNeIDJob, manage, view } from "utils/constants";
import { handleError } from "utils/handleError";
import { VNeIDJobEditor } from "./VNeIDJobEditor";

export const VNeIDJobList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    // const { t, i18n } = useTranslation("common");
    const { t, i18n } = useTranslation(["vneid-job", "common", "user"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };
    const optionsState = [
        { label: t("vneid-job.running"), value: true },
        { label: t("vneid-job.paused"), value: false },
    ];

    const vneidJobContext = useContext(VNeIDJobContext);
    const { setVneidDialog, vneidDialog, setValueForm, submitted, setSubmitted, resetValueForm } = vneidJobContext;

    const [dataSearch, setDataSearch] = useState({ jobGroup: "", jobKey: "", jobStatus: null });
    const [optionServer, setOptionServer] = useState([]);
    const [optionServiceName, setOptionServiceName] = useState([]);

    const [listVNeIDJob, setListVNeIDJob] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);

    const [checkLoad, setCheckLoad] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);

    const [deleteDialog, setDeleteDialog] = useState(false);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
    });

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);
    useEffect(() => {
        if (submitted) {
            loadLazyData();
            setSubmitted(false);
        }
    }, [submitted]);

    useEffect(() => {
        getListServer();
        getListServiceName();
    }, []);

    const loadLazyData = () => {
        setLoading(true);
        setSelectedItem(null);
        findVNeIDJob(headers, lazyParams, dataSearch)
            .then((res) => {
                if (res.data.length > 0) {
                    setTotalRecords(res.data[0].toltalRecord ? parseInt(res.data[0].toltalRecord) : 0);
                    const dataRes = res.data;
                    dataRes?.forEach((e, i) => {
                        e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                    });
                    if (dataRes.length > 0) {
                        setSelectedItem(dataRes[0]);
                    }
                    setListVNeIDJob(dataRes);
                } else {
                    setListVNeIDJob([]);
                    setTotalRecords(0);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };
    const getListServer = () => {
        setLoading(true);
        setSelectedItem(null);
        listServerVNeIDJob(headers, {})
            .then((res) => {
                if (res.status === 200) {
                    setOptionServer(
                        res.data.map((e) => {
                            return { label: e, value: e };
                        })
                    );
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const getListServiceName = () => {
        setLoading(true);
        setSelectedItem(null);
        listServiceNameVNeIDJob(headers, {})
            .then((res) => {
                // console.log("res", res);
                if (res.status === 200) {
                    setOptionServiceName(
                        res.data.map((e) => {
                            return { label: e.name, value: e.code };
                        })
                    );
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    const searchOption = (
        <div className="grid">
            {/* nhóm công việc */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label className="col-fixed text-center" style={{ display: "flex", padding: "0.75rem 0px 0px 0.5rem" }} htmlFor="factoryName">
                        {t("vneid-job.group")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{ width: "100%" }}
                            id="jobGroup"
                            name="jobGroup"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setDataSearch({
                                    jobGroup: e.target.value,
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>
            {/* Key  */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "66px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0.5rem",
                        }}
                        htmlFor="jobKey"
                    >
                        {t("vneid-job.key")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{ width: "100%" }}
                            id="jobKey"
                            name="jobKey"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setDataSearch({
                                    ...dataSearch,
                                    jobKey: e.target.value,
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>
            {/* Trạng thái */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0.5rem",
                        }}
                        htmlFor="type"
                    >
                        {t("vneid-job.state")}
                    </label>
                    <Dropdown
                        className="col"
                        value={dataSearch.jobStatus}
                        style={{ width: "100%", margin: "7px" }}
                        showClear={true}
                        id="type"
                        name="type"
                        options={optionsState}
                        onChange={(e) => {
                            setCheckLoad(false);
                            setDataSearch({
                                ...dataSearch,
                                jobStatus: e.value,
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>

            {/* service name */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0.5rem",
                        }}
                        htmlFor="service-name"
                    >
                        {t("vneid-job.serviceName")}
                    </label>
                    <Dropdown
                        // className="col"
                        value={dataSearch.appCode}
                        // value={dataSearch.jobServer}
                        style={{ width: "100%", margin: "7px", height: "33px" }}
                        showClear={true}
                        id="service-name"
                        name="service-name"
                        options={optionServiceName}
                        onChange={(e) => {
                            setCheckLoad(false);
                            setDataSearch({
                                ...dataSearch,
                                appCode: e.value,
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>
            {/* server */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0.5rem",
                        }}
                        htmlFor="type"
                    >
                        {t("vneid-job.server")}
                    </label>
                    <Dropdown
                        className="col"
                        value={dataSearch.server}
                        // value={dataSearch.jobServer}
                        style={{ width: "100%", margin: "7px" }}
                        showClear={true}
                        id="type"
                        name="type"
                        options={optionServer}
                        onChange={(e) => {
                            setCheckLoad(false);
                            setDataSearch({
                                ...dataSearch,
                                server: e.value,
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>

            <div className="col-12 md:col-2 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0.5rem",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setCheckLoad(true);
                                setLazyParams({
                                    ...lazyParams,
                                    first: 0,
                                    page: 0,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const openNewDialog = () => {
        resetValueForm();
        setSubmitted(false);
        setVneidDialog(true);
    };

    const openEditDialog = () => {
        setValueForm({ ...selectedItem, action: actionUpdate });
        setSubmitted(false);
        setVneidDialog(true);
    };

    const openViewDialog = (item) => {
        setValueForm({ ...item, action: actionView });
        setSubmitted(false);
        setVneidDialog(true);
    };
    const openCloneDialog = (item) => {
        setValueForm({ ...item, action: actionClone });
        setSubmitted(false);
        setVneidDialog(true);
    };
    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };
    const confirmDeleteSelected = () => {
        setDeleteDialog(true);
    };
    const deleteSelectedAction = () => {
        callNodeVNeIDJob(headers, { ...selectedItem, param: "deleteJob" })
            .then(() => {
                setDeleteDialog(false);
                setCheckLoad(true);
                setLazyParams({ ...lazyParams });
                // resetTemplate();
                setSelectedItem(null);
                toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("vneid-job.deleted", { ns: "vneid-job", object: selectedItem.jobKey }), life: 3000 });
            })
            .catch((error) => handleError(toast, t, error));
    };
    const pauseJobAction = (item) => {
        callNodeVNeIDJob(headers, { ...item, param: "pauseJob" })
            .then(() => {
                setDeleteDialog(false);
                setCheckLoad(true);
                setLazyParams({ ...lazyParams });
                // resetTemplate();
                setSelectedItem(null);
                toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("vneid-job.pause", { ns: "vneid-job", object: item.jobKey }), life: 3000 });
            })
            .catch((error) => handleError(toast, t, error));
    };
    const resumeJobAction = (item) => {
        callNodeVNeIDJob(headers, { ...item, param: "resumeJob" })
            .then(() => {
                setDeleteDialog(false);
                setCheckLoad(true);
                setLazyParams({ ...lazyParams });
                // resetTemplate();
                setSelectedItem(null);
                toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("vneid-job.resume", { ns: "vneid-job", object: item.jobKey }), life: 3000 });
            })
            .catch((error) => handleError(toast, t, error));
    };
    const reloadJobAction = () => {
        reloadVNeIDJob(headers)
            .then((res) => {
                if (res.status === 200) {
                    loadLazyData();
                    toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("vneid-job.reloadJob"), life: 3000 });
                }
            })
            .catch((error) => handleError(toast, t, error));
    };
    const actionBodyVNeID = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions">
                {!rowData.jobStatus ? (
                    <Can I={view} a={VNeIDJob}>
                        <Button
                            icon={<AiFillPlayCircle style={{ width: 24, height: 24 }} />}
                            className="p-button-rounded p-button-text p-button-plain p-button mr-2"
                            // tooltip={t("view", { ns: "common" })}
                            onClick={() => resumeJobAction(rowData)}
                        />
                    </Can>
                ) : (
                    <Can I={view} a={VNeIDJob}>
                        <Button
                            icon={<AiFillPauseCircle style={{ width: 24, height: 24 }} />}
                            className="p-button-rounded p-button-text p-button-plain p-button mr-2"
                            // tooltip={t("view", { ns: "common" })}
                            onClick={() => pauseJobAction(rowData)}
                        />
                    </Can>
                )}
                <Can I={view} a={VNeIDJob}>
                    <Button icon="pi pi-eye" className="p-button-rounded p-button mr-2" tooltip={t("view", { ns: "common" })} onClick={() => openViewDialog(rowData)} />
                </Can>
                <Can I={manage} a={VNeIDJob}>
                    <Button
                        disabled={!rowData.multipleJobs}
                        icon={<FaRegClone />}
                        className="p-button-rounded p-button"
                        // tooltip={t("view", { ns: "common" })}
                        onClick={() => openCloneDialog(rowData)}
                    />
                </Can>
            </div>
        );
    };
    const actionTable = () => {
        return (
            <div className="grid">
                <div className="col-12 tex-center mt-2" style={{ display: "flex", justifyContent: "center" }}>
                    {/* tạo mới */}
                    <Can I={manage} a={VNeIDJob}>
                        <Button label={t("new", { ns: "common" })} icon="pi pi-plus" className="p-button mr-2" onClick={openNewDialog} />
                    </Can>
                    {/* sửa */}
                    <Can I={manage} a={VNeIDJob}>
                        <Button disabled={!selectedItem} label={t("edit", { ns: "common" })} icon="pi pi-pencil" className="p-button mr-2" onClick={openEditDialog} />
                    </Can>
                    {/* xóa */}
                    <Can I={manage} a={VNeIDJob}>
                        <Button disabled={!selectedItem} label={t("delete", { ns: "common" })} icon="pi pi-trash" className="p-button-danger p-button mr-2" onClick={confirmDeleteSelected} />
                    </Can>
                    {/* reload */}
                    {/* <Can I={view} a={VNeIDJob}>
                        <Button label={t("vneid-job.reloadJob")} icon={<HiRefresh />} className="p-button p-button mr-2" onClick={reloadJobAction} />
                    </Can> */}
                </div>
            </div>
        );
    };
    const paginatorVNeIDJob = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };
    const representativeBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold">{rowData.jobGroup}</span>
            </div>
        );
    };
    const statusTable = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{!!rowData.jobStatus ? t("vneid-job.running") : t("vneid-job.paused")}</span>
            </div>
        );
    };
    const headerTemplate = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold">{rowData.jobGroup}</span>
            </div>
        );
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("vneid-job.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12"></div>
                        <div className="col-12">
                            <BlockDetail title={t("vneid-job.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={listVNeIDJob}
                                    selectionMode="single"
                                    selection={selectedItem}
                                    onSelectionChange={(e) => {
                                        setSelectedItem(e.value);
                                    }}
                                    rowGroupHeaderTemplate={headerTemplate}
                                    dataKey="jobId"
                                    className="datatable-responsive p-datatable-sm"
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    // sortField={lazyParams.sortField}
                                    // sortOrder={lazyParams.sortOrder}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorVNeIDJob}
                                    emptyMessage="Không có dữ liệu"
                                    // scrollable
                                    // rowGroupMode="rowspan"
                                    rowGroupMode="subheader"
                                    groupRowsBy="jobGroup"
                                    sortMode="single"
                                    sortField="jobGroup"
                                    sortOrder={1}
                                    tableStyle={{ minWidth: "50rem" }}
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    {/* <Column field="jobGroup" header={t("vneid-job.group")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} /> */}
                                    {/* <Column field="jobGroup" header={t("vneid-job.group")} body={representativeBodyTemplate} style={{ minWidth: "100px", background: "#fff" }} /> */}
                                    <Column field="jobKey" header={t("vneid-job.key")} showFilterMatchModes={false} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="jobName" header={t("vneid-job.name")} showFilterMatchModes={false} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="className" header={t("vneid-job.class")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="cronExpression" header={t("vneid-job.crons")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="server" header={t("vneid-job.server")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="jobStatus" header={t("vneid-job.state")} body={statusTable} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    {/* <Column field="jobStatus" header={t("vneid-job.state")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} /> */}
                                    <Column field="description" header={t("vneid-job.description")} showFilterMatchModes={false} style={{ minWidth: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="configRow" header={t("vneid-job.rownum")} showFilterMatchModes={false} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column body={actionBodyVNeID} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                </DataTable>
                            </BlockDetail>
                        </div>
                    </div>
                    <div className="grid ">
                        <div className="col-12">{actionTable()}</div>
                    </div>
                    {vneidDialog && <VNeIDJobEditor optionServer={optionServer} />}
                    {/* <VNeIDJobEditor optionServer={optionServer} /> */}
                    <Confirmation
                        visible={deleteDialog}
                        hideAction={hideDeleteDialog}
                        processAction={deleteSelectedAction}
                        confirmMessage={
                            selectedItem && (
                                <span>
                                    {t("confirm.delete.selected", { ns: "common", object: t("vneid-job") })} <b>{selectedItem.jobKey}</b>?{" "}
                                </span>
                            )
                        }
                    />
                </div>
            </div>
        </div>
    );
};
